import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useCaseRequestWizard } from '../hooks/useCaseRequestWizard';
import { criminalWizardPath } from '../pages/wizard/criminal/CriminalWizardShell';
import CriminalStep1CaseOverviewPage from '../pages/wizard/criminal/CriminalStep1CaseOverviewPage';
import CriminalStep2VictimDetailsPage from '../pages/wizard/criminal/CriminalStep2VictimDetailsPage';
import CriminalStep3OffenceAccusedPage from '../pages/wizard/criminal/CriminalStep3OffenceAccusedPage';
import CriminalStep4SubmissionDeliveryPage from '../pages/wizard/criminal/CriminalStep4SubmissionDeliveryPage';
import CriminalStep5UploadDocumentsPage from '../pages/wizard/criminal/CriminalStep5UploadDocumentsPage';
import CriminalReviewPage from '../pages/wizard/criminal/CriminalReviewPage';
import CivilAdviseStep1CaseOverviewPage from '../pages/wizard/civilAdvise/CivilAdviseStep1CaseOverviewPage';
import CivilAdviseStep2TimelinePage from '../pages/wizard/civilAdvise/CivilAdviseStep2TimelinePage';
import CivilAdviseStep3SubmissionDeliveryPage from '../pages/wizard/civilAdvise/CivilAdviseStep3SubmissionDeliveryPage';
import CivilAdviseStep4UploadDocumentsPage from '../pages/wizard/civilAdvise/CivilAdviseStep4UploadDocumentsPage';
import CivilAdviseReviewPage from '../pages/wizard/civilAdvise/CivilAdviseReviewPage';
import CivilLitigationStep1CaseOverviewPage from '../pages/wizard/civilLitigation/CivilLitigationStep1CaseOverviewPage';
import CivilLitigationStep2PartyDetailsPage from '../pages/wizard/civilLitigation/CivilLitigationStep2PartyDetailsPage';
import CivilLitigationStep3IncidentDetailsPage from '../pages/wizard/civilLitigation/CivilLitigationStep3IncidentDetailsPage';
import CivilLitigationStep4SubmissionDeliveryPage from '../pages/wizard/civilLitigation/CivilLitigationStep4SubmissionDeliveryPage';
import CivilLitigationStep5UploadDocumentsPage from '../pages/wizard/civilLitigation/CivilLitigationStep5UploadDocumentsPage';
import CivilLitigationReviewPage from '../pages/wizard/civilLitigation/CivilLitigationReviewPage';
import CriminalAppellateStep1CaseOverviewPage from '../pages/wizard/criminalAppellate/CriminalAppellateStep1CaseOverviewPage';
import CriminalAppellateStep2PartyDetailsPage from '../pages/wizard/criminalAppellate/CriminalAppellateStep2PartyDetailsPage';
import CriminalAppellateStep3TimelinePage from '../pages/wizard/criminalAppellate/CriminalAppellateStep3TimelinePage';
import CriminalAppellateStep4SubmissionDeliveryPage from '../pages/wizard/criminalAppellate/CriminalAppellateStep4SubmissionDeliveryPage';
import CriminalAppellateStep5UploadDocumentsPage from '../pages/wizard/criminalAppellate/CriminalAppellateStep5UploadDocumentsPage';
import CriminalAppellateReviewPage from '../pages/wizard/criminalAppellate/CriminalAppellateReviewPage';
import NominationStep1CaseOverviewPage from '../pages/wizard/nomination/NominationStep1CaseOverviewPage';
import NominationStep2TimelinePage from '../pages/wizard/nomination/NominationStep2TimelinePage';
import NominationStep3SubmissionDeliveryPage from '../pages/wizard/nomination/NominationStep3SubmissionDeliveryPage';
import NominationStep4UploadDocumentsPage from '../pages/wizard/nomination/NominationStep4UploadDocumentsPage';
import NominationReviewPage from '../pages/wizard/nomination/NominationReviewPage';
import { nominationWizardPath } from '../pages/wizard/nomination/NominationWizardShell';
import RightToInformationStep1CaseOverviewPage from '../pages/wizard/rightToInformation/RightToInformationStep1CaseOverviewPage';
import RightToInformationStep2TimelinePage from '../pages/wizard/rightToInformation/RightToInformationStep2TimelinePage';
import RightToInformationStep3SubmissionDeliveryPage from '../pages/wizard/rightToInformation/RightToInformationStep3SubmissionDeliveryPage';
import RightToInformationStep4UploadDocumentsPage from '../pages/wizard/rightToInformation/RightToInformationStep4UploadDocumentsPage';
import RightToInformationReviewPage from '../pages/wizard/rightToInformation/RightToInformationReviewPage';
import { rightToInformationWizardPath } from '../pages/wizard/rightToInformation/RightToInformationWizardShell';
import ExtraditionMlaStep1CaseOverviewPage from '../pages/wizard/extraditionMla/ExtraditionMlaStep1CaseOverviewPage';
import ExtraditionMlaStep2AccusedPersonPage from '../pages/wizard/extraditionMla/ExtraditionMlaStep2AccusedPersonPage';
import ExtraditionMlaStep3LegalExtraditionPage from '../pages/wizard/extraditionMla/ExtraditionMlaStep3LegalExtraditionPage';
import ExtraditionMlaStep4TimelinePage from '../pages/wizard/extraditionMla/ExtraditionMlaStep4TimelinePage';
import ExtraditionMlaStep4SubmissionDeliveryPage from '../pages/wizard/extraditionMla/ExtraditionMlaStep4SubmissionDeliveryPage';
import ExtraditionMlaStep5UploadDocumentsPage from '../pages/wizard/extraditionMla/ExtraditionMlaStep5UploadDocumentsPage';
import ExtraditionMlaReviewPage from '../pages/wizard/extraditionMla/ExtraditionMlaReviewPage';
import CivilAppellateStep1CaseOverviewPage from '../pages/wizard/civilAppellate/CivilAppellateStep1CaseOverviewPage';
import CivilAppellateStep2PartyDetailsPage from '../pages/wizard/civilAppellate/CivilAppellateStep2PartyDetailsPage';
import CivilAppellateStep3TimelinePage from '../pages/wizard/civilAppellate/CivilAppellateStep3TimelinePage';
import CivilAppellateStep4SubmissionDeliveryPage from '../pages/wizard/civilAppellate/CivilAppellateStep4SubmissionDeliveryPage';
import CivilAppellateStep5UploadDocumentsPage from '../pages/wizard/civilAppellate/CivilAppellateStep5UploadDocumentsPage';
import CivilAppellateReviewPage from '../pages/wizard/civilAppellate/CivilAppellateReviewPage';
import AttorneyGeneralStep1CaseOverviewPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep1CaseOverviewPage';
import AttorneyGeneralStep2PartyDetailsPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep2PartyDetailsPage';
import AttorneyGeneralStep3IncidentDetailsPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep3IncidentDetailsPage';
import AttorneyGeneralStep4VictimDetailsPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep4VictimDetailsPage';
import AttorneyGeneralStep5OffenceAccusedPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep5OffenceAccusedPage';
import AttorneyGeneralStep6AccusedPersonPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep6AccusedPersonPage';
import AttorneyGeneralStep7LegalExtraditionPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep7LegalExtraditionPage';
import AttorneyGeneralStep8PetitionerDetailsPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep8PetitionerDetailsPage';
import AttorneyGeneralStep9RightToInformationPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep9RightToInformationPage';
import AttorneyGeneralStep10TimelinePage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep10TimelinePage';
import AttorneyGeneralStep11SubmissionPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep11SubmissionPage';
import AttorneyGeneralStep12UploadDocumentsPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralStep12UploadDocumentsPage';
import AttorneyGeneralReviewPage from '../pages/wizard/attorneyGeneral/AttorneyGeneralReviewPage';
import { attorneyGeneralWizardPath } from '../pages/wizard/attorneyGeneral/AttorneyGeneralWizardShell';
import PublicPetitionStep3TimelinePage from '../pages/wizard/publicPetition/PublicPetitionStep3TimelinePage';
import { publicPetitionWizardPath } from '../pages/wizard/publicPetition/publicPetitionWizardShell';
import PublicPetitionStep4SubmissionDeliveryPage from '../pages/wizard/publicPetition/PublicPetitionStep4SubmissionDeliveryPage';
import PublicPetitionStep2PartiesInvolvedPage from '../pages/wizard/publicPetition/PublicPetitionStep2PartiesInvolvedPage';
import PublicPetitionStep1CaseOverviewPage from '../pages/wizard/publicPetition/PublicPetitionStep1CaseOverviewPage';
import PublicPetitionStep5UploadDocumentsPage from '../pages/wizard/publicPetition/PublicPetitionStep5UploadDocumentsPage';
import PublicPetitionReviewPage from '../pages/wizard/publicPetition/PublicPetitionReviewPage';

function RedirectToStep({ step }: { step: number }) {
  const { caseRequestId } = useParams();
  const { activeFlow } = useCaseRequestWizard();
  const id = (caseRequestId ?? '').trim();
  if (activeFlow === 'nomination-requests') {
    return <Navigate to={nominationWizardPath(step as 1 | 2 | 3 | 4, id || undefined)} replace />;
  }
  if (activeFlow === 'public-petition') {
    return <Navigate to={publicPetitionWizardPath(step as 1 | 2 | 3 | 4 | 5, id || undefined)} replace />;
  }
  if (activeFlow === 'right-to-information') {
    return <Navigate to={rightToInformationWizardPath(step as 1 | 2 | 3 | 4, id || undefined)} replace />;
  }
  if (activeFlow === 'attorney-general') {
    return (
      <Navigate
        to={attorneyGeneralWizardPath(step as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12, id || undefined)}
        replace
      />
    );
  }
  return <Navigate to={criminalWizardPath(step as 1 | 2 | 3 | 4 | 5, id || undefined)} replace />;
}

/** When activeFlow no longer matches a shared high step route, return to step 1. */
function RedirectToWizardStep1() {
  const { caseRequestId } = useParams();
  const id = (caseRequestId ?? '').trim();
  const target = id ? `/requests/new/step-1/${id}` : '/requests/new/step-1';
  return <Navigate to={target} replace />;
}

export function WizardStep1Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise') return <CivilAdviseStep1CaseOverviewPage />;
  if (activeFlow === 'civil-litigation') return <CivilLitigationStep1CaseOverviewPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateStep1CaseOverviewPage />;
  if (activeFlow === 'nomination-requests') return <NominationStep1CaseOverviewPage />;
 if (activeFlow === 'public-petition') return <PublicPetitionStep1CaseOverviewPage />;
  if (activeFlow === 'right-to-information') return <RightToInformationStep1CaseOverviewPage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep1CaseOverviewPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep1CaseOverviewPage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateStep1CaseOverviewPage />;
  return <CriminalStep1CaseOverviewPage />;
}

export function WizardStep2Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise') return <CivilAdviseStep2TimelinePage />;
  if (activeFlow === 'civil-litigation') return <CivilLitigationStep2PartyDetailsPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateStep2PartyDetailsPage />;
  if (activeFlow === 'nomination-requests') return <NominationStep2TimelinePage />;
 if (activeFlow === 'public-petition') return <PublicPetitionStep2PartiesInvolvedPage />;
  if (activeFlow === 'right-to-information') return <RightToInformationStep2TimelinePage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep2PartyDetailsPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep2AccusedPersonPage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateStep2PartyDetailsPage />;
  return <CriminalStep2VictimDetailsPage />;
}

export function WizardStep3Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise') return <CivilAdviseStep3SubmissionDeliveryPage />;
  if (activeFlow === 'civil-litigation') return <CivilLitigationStep3IncidentDetailsPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateStep3TimelinePage />;
  if (activeFlow === 'nomination-requests') return <NominationStep3SubmissionDeliveryPage />;
  if (activeFlow === 'public-petition') return <PublicPetitionStep3TimelinePage />;
  if (activeFlow === 'right-to-information') return <RightToInformationStep3SubmissionDeliveryPage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep3IncidentDetailsPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep3LegalExtraditionPage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateStep3TimelinePage />;
  return <CriminalStep3OffenceAccusedPage />;
}

export function WizardStep4Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise') return <CivilAdviseStep4UploadDocumentsPage />;
  if (activeFlow === 'civil-litigation') return <CivilLitigationStep4SubmissionDeliveryPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateStep4SubmissionDeliveryPage />;
  if (activeFlow === 'nomination-requests') return <NominationStep4UploadDocumentsPage />;
  if (activeFlow === 'public-petition') return <PublicPetitionStep4SubmissionDeliveryPage />;
  if (activeFlow === 'right-to-information') return <RightToInformationStep4UploadDocumentsPage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep4VictimDetailsPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep4TimelinePage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateStep4SubmissionDeliveryPage />;
  return <CriminalStep4SubmissionDeliveryPage />;
}

export function WizardStep5Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise' || activeFlow === 'nomination-requests' || activeFlow === 'right-to-information') {
    return <RedirectToStep step={4} />;
  }
  if (activeFlow === 'civil-litigation') return <CivilLitigationStep5UploadDocumentsPage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep5OffenceAccusedPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateStep5UploadDocumentsPage />;
  if (activeFlow === 'public-petition') return <PublicPetitionStep5UploadDocumentsPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep4SubmissionDeliveryPage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateStep5UploadDocumentsPage />;
  return <CriminalStep5UploadDocumentsPage />;
}

export function WizardStep6Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep6AccusedPersonPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaStep5UploadDocumentsPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep7Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep7LegalExtraditionPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep8Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep8PetitionerDetailsPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep9Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep9RightToInformationPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep10Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep10TimelinePage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep11Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep11SubmissionPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardStep12Page() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'attorney-general') return <AttorneyGeneralStep12UploadDocumentsPage />;
  return <RedirectToWizardStep1 />;
}

export function WizardReviewPage() {
  const { activeFlow } = useCaseRequestWizard();
  if (activeFlow === 'civil-advise') return <CivilAdviseReviewPage />;
  if (activeFlow === 'civil-litigation') return <CivilLitigationReviewPage />;
  if (activeFlow === 'criminal-appellate') return <CriminalAppellateReviewPage />;
  if (activeFlow === 'nomination-requests') return <NominationReviewPage />;
  if (activeFlow === 'public-petition') return <PublicPetitionReviewPage />;
  if (activeFlow === 'right-to-information') return <RightToInformationReviewPage />;
  if (activeFlow === 'attorney-general') return <AttorneyGeneralReviewPage />;
  if (activeFlow === 'extradition-mla') return <ExtraditionMlaReviewPage />;
  if (activeFlow === 'civil-appellate') return <CivilAppellateReviewPage />;
  return <CriminalReviewPage />;
}

export function LegacyWizardRedirect() {
  const location = useLocation();
  const match = location.pathname.match(
    /\/requests\/new\/civil-(?:advise|litigation)\/(step-\d+|review)(?:\/([^/]+))?$/,
  );
  if (match) {
    const target = match[2]
      ? `/requests/new/${match[1]}/${match[2]}`
      : `/requests/new/${match[1]}`;
    return <Navigate to={`${target}${location.search}`} replace />;
  }
  return <Navigate to="/requests/new/step-1" replace />;
}
